<div>
  <img src='assets/images/svg-loaders/circles.svg'>
  <h3>{{textLoader}}</h3>
</div>
